import React, { useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import ProjectService from "../services/ProjectService";
import ProjectTeamService from "../services/ProjectTeamService";
// import RoleMasterService from "../services/RoleMasterService";
import UserService from "../services/EmployeeService";
import Breadcrumb from "../components/Breadcrumb";
import StorageService from "../services/StorageService";
import Loading from "../components/loading";

import ReactPaginate from "react-paginate";
import ScreenData from "../config/ScreenData";
// import EmployeePermissionService from "../services/EmployeePermissionService";
import { useNavigate } from "react-router-dom";
import utility from "../utils/utility";
import usePermission from "../utils/UsePermission";
import UnAuthorized from "../views/Unathorized";
import MessageDialog from "../components/MessageDialog";

export default function AddProjectTeam() {
  const [projects, setProjects] = useState([]);
  const navigate = useNavigate();
  // const [roles, setRoles] = useState([]);
  const [assignedList, setAssignedList] = useState([]);
  const [selectedProjectId, setSelectedProjectId] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [employeeSearchText, setEmployeeSearchText] = useState(""); // ONLY name

  // Separate Page + Modal Messages
  const [pageMessage, setPageMessage] = useState("");
  const [pageMsgType, setPageMsgType] = useState("error");

  const [modalMessage, setModalMessage] = useState("");
  const [modalMsgType, setModalMsgType] = useState("error");

  const [employees, setEmployees] = useState([]);
  const [editData, setEditData] = useState(null);
  const [filteredEmployees, setFilteredEmployees] = useState([]);
  const [selected, setSelected] = useState(null);

  // const [messageTimer, setMessageTimer] = useState(null);

  const login = StorageService.loginData();
  const { register, reset, getValues, watch, setValue } = useForm();
  const getToday = () => new Date().toISOString().slice(0, 10);
  const [employeeSearch, setEmployeeSearch] = useState("");
  const [showEmployeeDropdown, setShowEmployeeDropdown] = useState(false);
  const employeeDropdownRef = useRef(null);

  const selectedCompanyId = StorageService.activeCompany().companyId;
  const [tableEmployeeSearch, setTableEmployeeSearch] = useState("");
  const [topEmployeeSearch, setTopEmployeeSearch] = useState("");
  const [selectedEmployeeId, setSelectedEmployeeId] = useState(null);
  const [showTopEmployeeDropdown, setShowTopEmployeeDropdown] = useState(false);
  const topEmployeeDropdownRef = useRef(null);

  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;

  // -------------------------------
  // Auto Hide Message Handlers
  // -------------------------------


  const showPageMessage = (msg, type = "error") => {
    setPageMessage(msg);
    setPageMsgType(type);

    // if (messageTimer) clearTimeout(messageTimer);

    // const timer = setTimeout(() => {
    //   setPageMessage("");
    // }, 3000);

    // setMessageTimer(timer);
  };
  const { permission, can } = usePermission(
    ScreenData.Project_Team,
    showPageMessage
  );

  const showModalMessage = (msg, type = "error") => {
    setModalMessage(msg);
    setModalMsgType(type);

    // if (messageTimer) clearTimeout(messageTimer);

    // const timer = setTimeout(() => {
    //   setModalMessage("");
    // }, 3000);

    // setMessageTimer(timer);
  };

  const autoFilteredEmployees = employeeSearch.trim()
    ? filteredEmployees.filter((e) =>
      `${e.firstName} ${e.lastName} ${e.roleName} ${e.employeeCode}`
        .toLowerCase()
        .includes(employeeSearch.toLowerCase())
    )
    : filteredEmployees;

  const topFilteredEmployees = topEmployeeSearch
    ? filteredEmployees.filter((e) =>
      `${e.firstName} ${e.lastName} ${e.roleName} ${e.employeeCode}`
        .toLowerCase()
        .includes(topEmployeeSearch.toLowerCase())
    )
    : filteredEmployees;



  // -------------------------------
  // Load Data
  // -------------------------------
  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const companyId = StorageService.activeCompany().companyId;
        const projRes = await ProjectService.getActive(companyId);
        setProjects(projRes?.data || projRes || []);
      } catch {
        showPageMessage("Failed to load projects", "danger");
      }
    };

    // const fetchRoles = async () => {
    //   try {
    //     const res = await RoleMasterService.getAllRoles();
    //     if (res.status) setRoles(res.data);
    //   } catch {
    //     showPageMessage("Failed to load roles", "danger");
    //   }
    // };

    const fetchEmployees = async () => {
      try {
        const selectedCompanyId = StorageService.activeCompany().companyId;

        if (!selectedCompanyId) {
          setEmployees([]);
          setFilteredEmployees([]);
          return;
        }

        const res = await UserService.getServiceUsers(selectedCompanyId);

        // const list = Array.isArray(res) ? res : [];

        const list = res?.data || [];
        setEmployees(list);
        setFilteredEmployees(
          list
        );
      } catch {
        showPageMessage("Failed to load employees", "danger");
        setEmployees([]);
        setFilteredEmployees([]);
      }
    };
    fetchProjects();
    // fetchRoles();
    fetchEmployees();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        topEmployeeDropdownRef.current &&
        !topEmployeeDropdownRef.current.contains(event.target)
      ) {
        setShowTopEmployeeDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    // 🔁 When project changes, reset selection state
    setSelected(null);
    setEditData(null);
    setPageMessage("");
  }, [selectedProjectId]);



  const fetchAssignedEmployees = async (projectId) => {
    setLoading(true);
    try {
      const res = await ProjectTeamService.getAll();
      const filtered = Array.isArray(res)
        ? res.filter((t) => Number(t.projectId) === Number(projectId))
        : [];

      setAssignedList(filtered);
      setSelected([]);
    } catch {
      showPageMessage("Failed to fetch assigned employees", "danger");
    } finally {
      setLoading(false);
    }
  };

  const filteredAssignedList = assignedList.filter((item) => {
    let match = true;

    // ✅ COMPANY FILTER (MANDATORY)
    match = match && Number(item.companyId) === Number(selectedCompanyId);

    // ✅ Employee NAME filter
    // if (employeeSearchText.trim()) {
    //   const fullName = `${item.firstName} ${item.lastName}`.toLowerCase();
    //   match = match && fullName.includes(employeeSearchText.toLowerCase());
    // }

    // ✅ Project filter
    // if (selectedProjectId) {
    //   match = match && Number(item.projectId) === Number(selectedProjectId);
    // }

    return match;
  });

  const resetEmployeeDropdown = () => {
    setEmployeeSearch("");
    setShowEmployeeDropdown(false);
    setValue("employeeId", "");
  };




  useEffect(() => {
    if (!topEmployeeSearch) {
      setSelectedEmployeeId(null);
    }
  }, [topEmployeeSearch]);

  // -------------------------------
  // Modifiers (Add / Modify)
  // -------------------------------
  const handleModify = async () => {
    setPageMessage("");

    if (assignedList.length === 0) {
      showPageMessage("No records found to modify.", "danger");
      return;
    }

    if (!selected) {
      showPageMessage("Please select a record to modify.", "danger");
      return;
    }

    const row = assignedList.find((u) => u.id === selected);

    if (!row) {
      showPageMessage("Selected record not found.", "danger");
      return;
    }

    try {
      const res = await ProjectTeamService.getById(row.id);
      const data = res?.data?.data || res?.data?.[0] || res?.data || res;

      setEditData(data);

      // setSelectedProjectId(data.projectId);
      setFilteredEmployees(
        employees.filter(emp => emp.status === "Active")
      );

      reset({
        employeeId: data.employeeId || "",
        assignedDate: data.assignedDate?.slice(0, 10) || "",
        endDate: data.endDate ? data.endDate.slice(0, 10) : "",
      });

      if (data.employeeId) {
        const emp = employees.find(e => e.id === data.employeeId);
        if (emp) {
          setEmployeeSearch(`${emp.firstName} ${emp.lastName}`);
        }
      }

      setShowEmployeeDropdown(false);
      setModalMessage("");
      setShowModal(true);
    } catch (ex) {
      showPageMessage("Error loading selected record.", "danger");
    }
  };

  // const indexOfLast = currentPage * itemsPerPage;
  // const indexOfFirst = indexOfLast - itemsPerPage;

  // const currentData = filteredAssignedList.slice(
  //   indexOfFirst,
  //   indexOfLast
  // );

  const handleAddBtn = () => {
    setPageMessage("");
    setEditData(null);
    setSelected(null);
    //setFilteredEmployees([]);
    if (!selectedProjectId) {
      showPageMessage("Select a project to add", "danger");
      return;
    }
    setFilteredEmployees(employees);
    setModalMessage("");

    reset({
      // roleId: "",
      employeeId: "",
      assignedDate: getToday(),
      endDate: "",
    });

    resetEmployeeDropdown();
    setShowModal(true);
  };


  const handleSelect = (id) => {
    setSelected(id);
  };


  useEffect(() => {
    setCurrentPage(1);
  }, [selectedProjectId, employeeSearchText]);

  // -------------------------------
  // Save / Update
  // -------------------------------
  const handleAddEmployee = async () => {
    setModalMessage("");

    const data = getValues();

    if (!data.employeeId || !data.assignedDate) {
      showModalMessage("⚠ Please fill all fields!", "danger");
      return;
    }

    if (data.endDate) {
      const start = new Date(data.assignedDate);
      const end = new Date(data.endDate);

      if (start > end) {
        showModalMessage(
          "⚠ Start Date cannot be greater than End Date!",
          "danger"
        );
        return;
      }
    }

    const payload = {
      // projectId: selectedProjectId,
      projectId: editData ? editData.projectId : selectedProjectId,
      employeeId: data.employeeId,
      roleId: data.roleId || null,
      assignedDate: data.assignedDate,
      endDate: data.endDate || null,
      status: "Active",
      companyId: selectedCompanyId,
      createdBy: login.employeeId,
      updatedBy: login.employeeId,
    };

    try {
      if (editData) {
        await ProjectTeamService.update(editData.id, payload);
      } else {
        await ProjectTeamService.create(payload);
      }

      // ALWAYS reload from backend
      await loadAllAssignedEmployees();

      showModalMessage("Employee saved successfully!", "success");

      setTimeout(() => {
        setShowModal(false);
        reset();
      }, 800);
    } catch (err) {
      showModalMessage(
        err.response?.data?.message || "Internal server error!",
        "danger"
      );
    }
  };

  useEffect(() => {
    if (permission === null) return;

    if (permission.canView !== 1) {
      setLoading(false);
      return;
    }

    loadAllAssignedEmployees();
  }, [currentPage, permission, employeeSearchText, selectedProjectId]);

  useEffect(() => {
    if (!showModal) {
      setSelected(null);
    }
  }, [assignedList, selectedProjectId, employeeSearchText]);


  const loadAllAssignedEmployees = async () => {
    setLoading(true);
    try {
      const res = await ProjectTeamService.getAll(currentPage, itemsPerPage, employeeSearchText, selectedProjectId);

      // setAssignedList(res?.data || []);
      // setPageCount(res?.totalPages || 0);

      setAssignedList(res?.data?.data || []);
      setPageCount(res?.pagination?.totalPages || 0);
    } catch {
      showPageMessage("Failed to fetch assigned employees", "danger");
    } finally {
      setLoading(false);
    }
  };


  const getEmployeeName = (id) => {
    const emp = employees.find((e) => e.id == id);
    return emp ? `${emp.firstName} ${emp.lastName}` : "—";
  };

  const getRoleNameByEmployee = (employeeId) => {
    const emp = employees.find(e => e.id == employeeId);
    return emp?.roleName || "—";
  };


  // const getRoleName = (id) => {
  //   const role = roles.find((r) => r.id == id);
  //   return role ? role.roleName : "—";
  // };

  const getStatusLabel = (value) => {
    if (!value) return "Inactive";
    const v = value.toString().trim().toLowerCase();
    return v === "1" || v === "active" ? "Active" : "Inactive";
  };

  if (permission === null) {
    return <div className="text-center mt-5">Loading...</div>;
  }

  if (!permission || permission.canView !== 1) {
    return <UnAuthorized />;
  }

  const formatDate = (date) => {
    return date ? new Date(date).toLocaleDateString("en-GB") : "—";
  };

  return (
    <>
      <Breadcrumb pageTitle="Assign Project Team" secondTitle="Projects" />

      <MessageDialog
        message={pageMessage || modalMessage}
        type={
          (pageMsgType === "success" || modalMsgType === "success")
            ? "success"
            : "error"
        }
        setMessage={(msg) => {
          setPageMessage("");
          setModalMessage("");
        }}
        setMsgType={() => { }}
      />

      <div className="row">
        {/* Select Project */}
        <div className="card p-3 mb-3">
          <div className="row align-items-end">

            {/* EMPLOYEE SEARCH FIRST */}
            <div className="col-md-6 position-relative" ref={topEmployeeDropdownRef}>
              <label className="form-label">Search Employee</label>

              <input
                type="text"
                className="form-control"
                placeholder="Type employee name / role / code..."
                value={topEmployeeSearch}
                onChange={(e) => {
                  setTopEmployeeSearch(e.target.value);
                  setEmployeeSearchText(e.target.value); // user typing name
                  setShowTopEmployeeDropdown(true);
                  setSelectedEmployeeId(null);
                }}
                onFocus={() => setShowTopEmployeeDropdown(true)}
              />

              {showTopEmployeeDropdown && (
                <ul
                  className="list-group position-absolute"
                  style={{ zIndex: 2000, maxHeight: "180px", overflowY: "auto", left: 0, right: 0 }}
                >
                  {topFilteredEmployees.length > 0 ? (
                    topFilteredEmployees.map((e) => (
                      <li
                        key={e.id}
                        className="list-group-item list-group-item-action"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setTopEmployeeSearch(
                            `${e.firstName} ${e.lastName} --- ${e.roleName} --- ${e.employeeCode}`
                          );
                          setEmployeeSearchText(`${e.firstName} ${e.lastName}`);
                          setSelectedEmployeeId(e.id);
                          setShowTopEmployeeDropdown(false);
                        }}
                      >
                        <div className="fw-semibold">
                          {e.firstName} {e.lastName}
                        </div>
                        <div className="text-muted small">
                          {e.roleName} --- {e.employeeCode}
                        </div>
                      </li>
                    ))
                  ) : (
                    <li className="list-group-item text-muted">
                      No matching employees
                    </li>
                  )}
                </ul>
              )}
            </div>

            {/* PROJECT SECOND */}
            <div className="col-md-6">
              <label className="form-label">Project</label>
              <select
                className="form-select"
                value={selectedProjectId}
                onChange={(e) => {
                  const pid = Number(e.target.value);
                  setSelectedProjectId(pid);
                  // fetchAssignedEmployees(pid);
                }}
              >
                <option value="">All Projects</option>
                {projects.map((p) => (
                  <option key={p.id} value={p.id}>
                    {p.projectName}-{p.projectCode}
                  </option>
                ))}
              </select>
            </div>

          </div>
        </div>

        {/* Assigned Employees Table */}
        <div className="card">
          <div className="card-header d-flex justify-content-between">
            <h5>Assigned Employees</h5>

            <div>
              {can("canAdd") && (
                <button
                  className="btn btn-success me-2"
                  onClick={handleAddBtn}
                >
                  <i className="ti ti-plus me-1"></i> Add Employee
                </button>
              )}

              {can("canModify") && (
                <button
                  className="btn btn-warning"
                  disabled={!selected}
                  onClick={handleModify}
                >
                  <i className="ti ti-pencil me-1"></i> Modify
                </button>
              )}
            </div>
          </div>

          <div className="card-body">
            {/* {pageMessage && (
              <div
                className={`alert alert-${pageMsgType} d-flex justify-content-between align-items-center py-2`}
              >
                <span>{pageMessage}</span>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setPageMessage("")}
                ></button>
              </div>
            )} */}


            <table className="table table-bordered">
              <thead>
                <tr>
                  <th></th>
                  <th>Employee</th>
                  <th>Role</th>
                  <th>Project</th>
                  <th>Assigned Date</th>
                  <th>End Date</th>
                  {/* <th>Status</th> */}
                </tr>
              </thead>

              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="6" className="text-center py-4">
                      <Loading />
                    </td>
                  </tr>
                ) : filteredAssignedList.length > 0 ? (
                  filteredAssignedList.map((user) => (
                    // currentData.map((user) => (
                    <tr key={user.id}>
                      <td>
                        <input
                          type="radio"
                          checked={selected === user.id}
                          onChange={() => handleSelect(user.id)}
                        />
                      </td>

                      {/* ✅ Employee Name */}
                      <td>{user.firstName} {user.lastName}</td>

                      {/* ✅ Role */}
                      <td>{getRoleNameByEmployee(user.employeeId)}</td>

                      {/* ✅ Project */}
                      <td>{user.projectName} - {user.projectCode}</td>

                      {/* ✅ Assigned Date */}
                      <td>
                        {user.assignedDate
                          ? utility.formatDateDDMMMYYYY(user.assignedDate)
                          : "—"}
                      </td>

                      {/* ✅ End Date */}
                      <td>
                        {user.endDate
                          ? utility.formatDateDDMMMYYYY(user.endDate)
                          : "—"}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center text-muted">
                      No employees assigned
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            <ReactPaginate
              forcePage={currentPage - 1}
              breakLabel="..."
              nextLabel="Next >"
              previousLabel="< Previous"
              onPageChange={(e) => setCurrentPage(e.selected + 1)}
              pageCount={pageCount}   // ✅ IMPORTANT
              pageRangeDisplayed={3}
              marginPagesDisplayed={2}
              containerClassName="pagination-container"
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              activeClassName="active"
            />
          </div>
        </div>

        {/* MODAL */}
        {showModal && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0,0,0,0.5)",
              zIndex: 999,
            }}
          >
            <div
              onClick={(e) => {
                if (!employeeDropdownRef.current?.contains(e.target)) {
                  setShowEmployeeDropdown(false);
                }
              }}
              style={{
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "400px",
                background: "#fff",
                padding: "20px",
                borderRadius: "8px",
                zIndex: 1000,
              }}
            >
              <h5>{editData ? "Modify Employee Assignment" : "Assign Employee"}</h5>

              {/* {modalMessage && (
                <div className={`alert alert-${modalMsgType} py-2`}>
                  {modalMessage}
                </div>
              )} */}

              {/* <div className="mb-3">
                <label className="form-label">Role</label>
                <select className="form-select" {...register("roleId")}>
                  <option value="">Select Role</option>
                  {roles.map((r) => (
                    <option key={r.id} value={r.id}>
                      {r.roleName}
                    </option>
                  ))}
                </select>
              </div> */}

              <div className="mb-3">
                <label className="form-label">Employee</label>
                {/* <select className="form-select" {...register("employeeId")}>
                  <option value="">Select Employee</option>
                  {filteredEmployees.length > 0 ? (
                    filteredEmployees.map((e) => (
                      <option key={e.id} value={e.id}>
                        {e.firstName} {e.lastName}
                      </option>
                    ))
                  ) : (
                    <option value="" disabled>
                      {watch("roleId")
                        ? "No employees for selected role"
                        : "Select role first"}
                    </option>
                  )}
                </select> */}

                {/* <select className="form-select" {...register("employeeId")}>
                  <option value="">Select Employee</option>
                  {filteredEmployees.length > 0 ? (
                    filteredEmployees.map((e) => (
                      <option key={e.id} value={e.id}>
                        {e.firstName} {e.lastName}
                      </option>
                    ))
                  ) : (
                    <option value="" disabled>
                      {watch("roleId") ? "No employees for selected role" : "Select role first"}
                    </option>
                  )}
                </select> */}
                <div className="position-relative" ref={employeeDropdownRef}>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Type employee name / role / code..."
                    value={employeeSearch}
                    onChange={(e) => {
                      setEmployeeSearch(e.target.value);
                      setShowEmployeeDropdown(true);
                      setValue("employeeId", "");
                    }}
                    onFocus={() => {
                      setShowEmployeeDropdown(true);
                    }}
                    onClick={(e) => {
                      e.stopPropagation(); // ✅ IMPORTANT FIX
                      setShowEmployeeDropdown(true);
                    }}
                  />

                  {showEmployeeDropdown && (
                    <ul
                      className="list-group position-absolute w-100"
                      style={{ zIndex: 2000, maxHeight: "170px", overflowY: "auto" }}
                    >
                      {autoFilteredEmployees.length > 0 ? (
                        autoFilteredEmployees.map((e) => (
                          <li
                            key={e.id}
                            className="list-group-item list-group-item-action"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              setEmployeeSearch(
                                `${e.firstName} ${e.lastName} --- ${e.roleName} --- ${e.employeeCode}`
                              );
                              setValue("employeeId", e.id);
                              setShowEmployeeDropdown(false);
                            }}
                          >
                            <div className="fw-semibold">
                              {e.firstName} {e.lastName}
                            </div>
                            <div className="text-muted small">
                              {e.roleName} --- {e.employeeCode}
                            </div>
                          </li>
                        ))
                      ) : (
                        <li className="list-group-item text-muted">
                          No matching employees
                        </li>
                      )}
                    </ul>
                  )}
                </div>
              </div>

              <div className="mb-3">
                <label className="form-label">Start Date</label>
                <input
                  type="date"
                  className="form-control"
                  {...register("assignedDate")}
                />
              </div>

              <div className="mb-3">
                <label className="form-label">End Date</label>
                <input
                  type="date"
                  className="form-control"
                  {...register("endDate")}
                />
              </div>

              <div className="d-flex justify-content-end gap-2">
                <button
                  className="btn btn-secondary"
                  onClick={() => {
                    setShowModal(false);
                    setEditData(null);
                    reset({
                      roleId: "",
                      employeeId: "",
                      assignedDate: "",
                      endDate: "",
                    });
                  }}
                >
                  <i className="ti ti-cancel me-1"></i> Cancel
                </button>

                <button className="btn btn-primary" onClick={handleAddEmployee}>
                  <i className="ti ti-circle-check me-1"></i>
                  {loading
                    ? editData
                      ? "Updating..."
                      : "Saving..."
                    : editData
                      ? "Update"
                      : "Save"}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
